import { FC } from 'react';

import { getChunks } from 'utils/clickme';
import { MODAL_ONE_LINE_ITEMS_COUNT } from 'utils/constants/common';

import Button, { ButtonAppearance } from 'bloko/blocks/button';
import Column from 'bloko/blocks/column';
import Modal, { ModalFooter, ModalHeader, ModalTitle } from 'bloko/blocks/modal';

interface Props {
    visible: boolean;
    setVisible: (payload: boolean) => unknown;
    titleTrl: string;
    items: Array<string>;
    closeTrl: string;
}

const AdditionalProfessionsModal: FC<Props> = ({ items, setVisible, visible, closeTrl, titleTrl }) => (
    <Modal visible={visible} onClose={() => setVisible(false)}>
        <ModalHeader>
            <ModalTitle>{titleTrl}</ModalTitle>
        </ModalHeader>
        <div>
            {getChunks(items, MODAL_ONE_LINE_ITEMS_COUNT).map((chunk, keyChunk) => (
                <Column key={keyChunk} xs="1" s="2" m="3" l="4">
                    <ul>
                        {chunk.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                </Column>
            ))}
        </div>
        <ModalFooter>
            <Button appearance={ButtonAppearance.Outlined} onClick={() => setVisible(false)}>
                {closeTrl}
            </Button>
        </ModalFooter>
    </Modal>
);

export default AdditionalProfessionsModal;
